/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type PatientLabOrderStatus =
  (typeof PatientLabOrderStatus)[keyof typeof PatientLabOrderStatus];

export const PatientLabOrderStatus = {
  in_progress: "in_progress",
  results_ready: "results_ready",
  completed: "completed",
} as const;
